export const REQUEST_URL = '/public/request';
export const REQUEST_SUB_URL = '/public/request/sub';
export const BASE_URL = window.location.pathname.startsWith(REQUEST_SUB_URL)
    ? REQUEST_SUB_URL
    : REQUEST_URL;
